import { useEffect, useRef, useState } from "react";

const sections = [
  { id: "work", label: "Work" },
  { id: "experience", label: "Experience" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];
export function PortfolioNavigation({
  theme,
  onTheme,
  onResume,
}: {
  theme: "light" | "dark";
  onTheme: () => void;
  onResume: () => void;
}) {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  const header = useRef<HTMLElement>(null);
  useEffect(() => {
    function escape(event: KeyboardEvent) {
      if (event.key === "Escape" && open) {
        setOpen(false);
        toggle.current?.focus();
      }
    }
    function outside(event: PointerEvent) {
      if (open && !header.current?.contains(event.target as Node))
        setOpen(false);
    }
    document.addEventListener("keydown", escape);
    document.addEventListener("pointerdown", outside);
    return () => {
      document.removeEventListener("keydown", escape);
      document.removeEventListener("pointerdown", outside);
    };
  }, [open]);
  return (
    <header className="portfolio-navigation" ref={header}>
      <div className="portfolio-nav-bar">
        <a
          className="portfolio-wordmark"
          href="#home"
          aria-label="kevinlhn home"
          onClick={() => setOpen(false)}
        >
          kevin<span>lhn</span>
        </a>
        <nav className="portfolio-primary" aria-label="Main navigation">
          {sections.map((item) => (
            <a key={item.id} href={`#${item.id}`}>
              {item.label}
            </a>
          ))}
        </nav>
        <div className="portfolio-nav-controls">
          <button
            className="portfolio-resume-trigger"
            onClick={() => {
              setOpen(false);
              onResume();
            }}
          >
            Résumé <span aria-hidden="true">↗</span>
          </button>
          <button
            className="portfolio-theme"
            onClick={onTheme}
            aria-label={`Switch to ${
              theme === "light" ? "dark" : "light"
            } mode`}
          >
            <svg aria-hidden="true" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8" />
              <path d="M12 4a8 8 0 0 0 0 16Z" fill="currentColor" />
            </svg>
          </button>
          <button
            className="portfolio-index-toggle"
            ref={toggle}
            aria-controls="portfolio-index"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            {open ? "Close" : "Menu"}
            <span aria-hidden="true">{open ? "−" : "+"}</span>
          </button>
        </div>
      </div>
      <nav
        id="portfolio-index"
        className="portfolio-index"
        aria-label="Mobile navigation"
        hidden={!open}
      >
        {sections.map((item) => (
          <a key={item.id} href={`#${item.id}`} onClick={() => setOpen(false)}>
            {item.label}
            <span aria-hidden="true">↗</span>
          </a>
        ))}
      </nav>
    </header>
  );
}
